export default __webpack_public_path__ + "f7a0a4b305a09f95379ae83796d7d4b4.svg";